import React from "react";
// NAVIGATION
import { useLocation } from "react-router-dom";
import useLeaveStandaloneEditor from "../../../customHooks/useLeaveStandaloneEditor";
// WIZARD
import { WizardProvider } from "../../setupWizard/WizardContext";
import StepLiftsFloors from "../../setupWizard/steps/StepLiftsFloors";

function LiftsEdit() {
  const leave = useLeaveStandaloneEditor("/edge-management/lifts");
  const location = useLocation();
  const idBank = new URLSearchParams(location.search).get("idBank");

  return (
    <WizardProvider>
      <StepLiftsFloors
        editBankId={idBank || undefined}
        standalone
        onSaveSuccess={leave}
        onCancel={leave}
      />
    </WizardProvider>
  );
}

export default LiftsEdit;
